// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import OptionsDropDown from '../../../shared/components/options-drop-down';

const RgaResponsibleUnitCriteria = props =>
    <div className='rga-responsible-unit-criteria'>
        <OptionsDropDown
            className='responsible-unit'
            isPlaceholderTranslated={false}
            isRequired={true}
            label='Responsible Unit'
            onChange={props.onResponsibleUnitChange}
            optionDisplayAttributes={['value']}
            optionKey='key'
            options={props.responsibleUnitList}
            placeholder='Select Responsible Unit'
            selectedValue={props.responsibleUnit}
        />
    </div>;

RgaResponsibleUnitCriteria.displayName = 'RgaResponsibleUnitCriteria';
RgaResponsibleUnitCriteria.propTypes = {
    onResponsibleUnitChange: PropTypes.func.isRequired,
    responsibleUnit: PropTypes.string.isRequired,
    responsibleUnitList: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired
};

export default RgaResponsibleUnitCriteria;



// WEBPACK FOOTER //
// ./src/rga/reports/components/rga-responsible-unit-criteria.js